import '../styling/NewCreateQuoteForm.css';
import userimage from '../resources/user.png'
import {useState} from 'react';
import {useEffect} from 'react';
import { useAuthContext } from '../hooks/useAuthContext';
import { useQuotesContext } from '../hooks/useQuotesContext';
import { useNavigate } from 'react-router-dom';
import AddClientList from '../components/AddClientList';
import API_BASE_URL from '../config.js';


const NewCreateQuoteForm = ({handleSuccess,handleError}) => {
    
    const navigate = useNavigate();

    const {user} = useAuthContext();

    const {dispatch} = useQuotesContext()

    const [client,setClient]= useState(null)
    const [clientListState, setClientListState] = useState(null)
    const [clientFirst, setClientFirst] = useState('')
    const [clientLast, setClientLast] = useState('')

    // client info:
    const[clientId,setClientID] = useState('');
    const[clientMessage, setClientMessage] = useState('')

    // quote info 
    const[quoteTotal,setQuoteTotal] = useState('')
    const [lineItems, setLineItems] = useState([
      {
        productService: '',
        quantity: 0,
        unitPrice: 0,
        total: 0,
      },
    ]);

    //error info 
    const[error, updateError] = useState('')



    // here we will do our post request to add a quote 
    const handleSubmit = async (e) => {
      e.preventDefault()

      if (e.nativeEvent.submitter.id !== 'saveQuoteButton') {
        return;
      }

      if(!user){
          handleError("You must be logged in!")
          return
      }

      
      if(client==null){
        handleError("You must select a client!")
        return
      }


      const quote = {client: {clientFirst, clientLast, client_id: clientId, clientMessage}, lineItems, quoteTotal}

      console.log(clientId)

      const response = await fetch(`${API_BASE_URL}/api/quote`, {
          method: "POST",
          body: JSON.stringify(quote),
          headers:{
              "Content-Type": 'application/json',
              "Authorization": `Bearer ${user.token}`
          }
      })

      const json = await response.json();

      if (!response.ok) {
        const errorMessage = typeof json.error === 'string' ? json.error : 'Please fill out all of the required fields';
        updateError(errorMessage);
        handleError(errorMessage);
    }

      if(response.ok){
          setClient(null)
          setClientMessage('')
          setQuoteTotal('')
          setLineItems([
            {
              productService: '',
              quantity: 0,
              unitPrice: 0,
              total: 0,
            },
          ])
          updateError("")
          dispatch({type: "CREATE_QUOTE", payload: json})
          // updateSuccess("Quote added successfully!")
          handleSuccess("Quote created successfully!")
      }



  }


    const updateCurrentClient = (currclient) => {
        setClient({currclient})
        setClientID(currclient._id);
        console.log("client id:", clientId)
        setClientFirst(currclient.clientFirst)
        setClientLast(currclient.clientLast)
        setClientListState(null);
    }

    const showClientList = () => {
        setClientListState(true);
    }

    

 
    
      const addLineItem = () => {
        setLineItems([...lineItems, { productService: '', quantity: 0, unitPrice: 0, total: 0 }]);
      };
      
      
    
      const updateLineItem = (index, field, value) => {
        const updatedLineItems = [...lineItems];
        if (field=="quantity"){
            updatedLineItems[index].quantity = value;
            updatedLineItems[index].total = value * updatedLineItems[index].unitPrice;

            setLineItems(updatedLineItems);
        
        let newquotetotal = 0;
        for(let total in lineItems){
            newquotetotal += lineItems[total].total
        }
        setQuoteTotal(`$ ${newquotetotal}`)
        }
        else if(field=="unitPrice"){
            updatedLineItems[index].unitPrice = value;
            updatedLineItems[index].total = value*updatedLineItems[index].quantity;
            setLineItems(updatedLineItems);
        
        let newquotetotal = 0;
        for(let total in lineItems){
            newquotetotal += lineItems[total].total
        }
        setQuoteTotal(`$ ${newquotetotal}`)
        }
        else if(field=="productService"){
          updatedLineItems[index].productService = value;
          setLineItems(updatedLineItems)
        }
        
      };

      const handleDelete = (index) => {
        const updatedLineItems = lineItems.filter((item, i) => i !== index);
        setLineItems(updatedLineItems);

        let newquotetotal = 0;
        for(let total in updatedLineItems){
            newquotetotal += lineItems[total].total
        }
        setQuoteTotal(`$ ${newquotetotal}`)
    };

    return ( 
        <form onSubmit={handleSubmit}>
        { clientListState ? <AddClientList updateCurrentClient={updateCurrentClient}></AddClientList> : 
        <div className="newcreatequoteformcontainer">
            <div className="newclientitle">
                <div className="newformleftcircle" id="quotecircle">
                <img src={userimage} alt="" />
                </div>
                <h1 className="text-3xl font-bold ml-4">Quote for:</h1>
                {!client && <button className="btn btn-primary" id="createquoteaddclient" onClick={showClientList}>Add a client</button>}
                {client && <h1 className="text-3xl font-bold ml-4 ">{client.currclient.clientFirst} {client.currclient.clientLast}</h1> }
                {client && <button className="btn btn-primary" id="createquoteaddclient" onClick={showClientList}>Change client</button>}

                </div>
                <div className="newquoteformparams">
                    <h1 id="param01"><b>Product/Service</b></h1>
                    <h1 id="param2"><b>Quantity</b></h1>
                    <h1 id="param3"><b>Unit Price</b></h1>
                    <h1 id="param4"><b>Line Total</b></h1>
                    
                </div>
                {lineItems.map((item, index) => (
                <div className="itemlines" key={index}>
                <input
                id="input1"
                type="text"
                placeholder="Enter Product/Service"
                className="input input-bordered input-success w-full max-w-xs"
                value={item.productService}
                onChange={(e) => updateLineItem(index, 'productService', e.target.value)}
                />
                <input
                id="input2"
                type="number"
                placeholder="Enter Quantity"
                className="input input-bordered input-success w-half max-w-xs"
                value={item.quantity}
                onChange={(e) => updateLineItem(index, 'quantity', e.target.value)}
                />
                <input
                id="input3"
                type="number"
                placeholder="Enter Price"
                className="input input-bordered input-success w-half max-w-xs"
                value={item.unitPrice}
                onChange={(e) => updateLineItem(index, 'unitPrice', e.target.value)}
                />
                <div className="linetotal">
                <h1 id="">{item.total}$</h1>
                </div>
                <div className="deleteitemdiv">
                <button className="btn btn-error btn-circle btn-outline" onClick={() => handleDelete(index)}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                </button>
                </div>
                
            </div>
            ))}
            <button className="btn btn-wide btn-outline btn-primary" id="addlineitem" onClick={addLineItem}>Add line item</button>

            <div className="messageandsave">
            <textarea className="textarea textarea-info textarea-lg w-full max-w-xs" placeholder="Client Message"
            value={clientMessage}
            onChange={(e) => setClientMessage(e.target.value)}>
            </textarea>
            <div className="totalnsave">
            <h1><b>Quote total:</b>{quoteTotal}</h1>
            <button className="btn btn-lg btn-outline btn-primary" type="submit" id="saveQuoteButton">Save quote</button>
            </div>
            </div>
        </div>}
        </form>
     );
}
 
export default NewCreateQuoteForm;